import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['community', 'paymentType']

  connect() {
    this.boundUpdate = this.updatePaymentTypes.bind(this)
    $(this.communityTarget).on('select2:select.paymentTypeFilter', this.boundUpdate)
  }

  disconnect() {
    if (this.hasCommunityTarget) {
      $(this.communityTarget).off('.paymentTypeFilter')
    }
  }

  get url() {
    return this.data.get("url")
  }

  updatePaymentTypes() {
    const communityId = $(this.communityTarget).val()
    if (!communityId || !this.hasPaymentTypeTarget) return

    $.ajax({
      url: this.url,
      data: { community_id: communityId },
      dataType: 'json',
      global: false,
      success: (data) => {
        const $select = $(this.paymentTypeTarget)
        const currentVal = $select.val()

        $select.select2('destroy')
        $select.find('option').not(':first').remove()

        data.forEach(item => {
          $select.append(new Option(item.text, item.id))
        })

        if (currentVal && $select.find(`option[value="${currentVal}"]`).length) {
          $select.val(currentVal)
        } else {
          $select.val('')
        }

        $select.select2()
      }
    })
  }
}
